import { Tag, Typography } from 'antd';
import styles from '.././../Dashboard/index.module.less';
import { formatDistanceToNow } from 'date-fns';
const { Text, Title } = Typography;

export default function TaskCard({ type, data }) {
  const relativeTime = formatDistanceToNow(new Date(data.createdAt), {
    addSuffix: true
  });
  return (
    <div
      className={
        'bg-white !rounded-lg py-2 px-3 flex justify-between sm:flex-row flex-col items-start sm:items-center'
      }
      style={{ border: '1px dashed #e5e7eb' }}
    >
      <div className="w-full">
        <div className="flex items-center justify-between gap-6 ">
          <Title level={5} className={styles.taskTitle} style={{ margin: 0 }}>
            {data.title}
          </Title>
        </div>
        <div className="">
          <Text type="secondary" className={styles.descriptionText}>
            {data.description}
          </Text>
        </div>
        <div className="flex items-center justify-between gap-6 ">
          <div>
            <Text type="secondary" className={styles.secondaryText}>
              {data.client.client_name} · {data.project.project} ·{' '}
              {`T${data.id}`}
            </Text>
          </div>
        </div>
      </div>
      <div className="flex justify-end w-full">
        {type === 'released_tasks' ? (
          <Tag color="red" className="font-semibold !m-0 !border-none !py-0.5">
            {data.release_count}x
          </Tag>
        ) : (
          <Tag color="red" className="font-semibold !m-0 !border-none !py-0.5">
            Created {relativeTime}
          </Tag>
        )}
      </div>
    </div>
  );
}
